import { Channel, ChannelFilters, StreamChat } from 'stream-chat';

export const conversationFilter = (
  channel: Channel,
  baseChannelFilters: ChannelFilters,
  session: StreamChat
) => {
  const meetsBasicRequirements = channel.type === baseChannelFilters?.type;

  if (!meetsBasicRequirements) return false;

  const isCreator = channel.data?.created_by?.id === session.user?.id;
  const hasMessages = channel?.state?.messages?.length > 0;

  return isCreator || hasMessages;
};
